import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Pro() {
  const navigate = useNavigate();
  const [showFaq, setShowFaq] = useState(null);

  const activites = [
    { emoji: '⚽', label: 'Coach sportif' },
    { emoji: '🍳', label: 'Atelier cuisine' },
    { emoji: '🎨', label: 'Cours de dessin' },
    { emoji: '🐟', label: 'Sortie peche' },
    { emoji: '🌿', label: 'Balade nature' },
    { emoji: '🎭', label: 'Theatre Cirque' },
    { emoji: '🔬', label: 'Sciences' },
    { emoji: '🏕️', label: 'Survie Outdoor' },
    { emoji: '🎸', label: 'Musique' },
    { emoji: '🧁', label: 'Patisserie' },
    { emoji: '🚴', label: 'Velo VTT' },
    { emoji: '🧘', label: 'Yoga enfants' },
  ];

  const etapes = [
    { num: '1', titre: 'Cree ton profil', desc: 'Presente-toi en 2 minutes — qui tu es, ta passion, ton experience.' },
    { num: '2', titre: 'Propose ton activite', desc: 'Decris ce que tu proposes, pour quel age, combien d enfants.' },
    { num: '3', titre: 'Les familles te contactent', desc: 'Directement par WhatsApp ou email — simple et rapide.' },
    { num: '4', titre: 'Tu animes, ils adorent', desc: 'Les familles laissent un avis. Ta reputation grandit.' },
  ];

  const faqs = [
    { q: 'Faut-il un diplome pour proposer une activite ?', r: 'Non — Wooki accepte les passionnes et les professionnels. Tu declares ton expertise sous ta propre responsabilite.' },
    { q: 'Est-ce gratuit ?', r: 'Oui — totalement gratuit pendant la phase de lancement. 0% commission. Tu gardes 100% de tes revenus.' },
    { q: 'Comment je suis paye ?', r: 'Directement par les familles — en especes ou virement le jour de l activite.' },
    { q: 'Qui est responsable en cas de probleme ?', r: 'Tu es prestataire independant. Wooki est une plateforme de mise en relation uniquement.' },
    { q: 'Les parents doivent-ils etre presents ?', r: 'Oui — regle Wooki non negociable. Les parents restent pendant toute l activite.' },
    { q: 'Combien d enfants par activite ?', r: 'Tu choisis toi-meme le minimum et le maximum. En general entre 5 et 20 enfants.' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7', fontFamily: 'Nunito, sans-serif' }}>
      <style>{`@keyframes pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.05)}} @keyframes fadeUp{from{transform:translateY(30px);opacity:0}to{transform:translateY(0);opacity:1}}`}</style>

      {/* HERO */}
      <div style={{ background: 'linear-gradient(135deg, #1C2B1E 0%, #2D7A52 60%, #3D9A6A 100%)', padding: '60px 24px 48px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: -60, right: -60, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />
        <div style={{ position: 'absolute', bottom: -40, left: -40, width: 150, height: 150, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />
        <div onClick={() => navigate('/feed')} style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.8rem', marginBottom: 24, cursor: 'pointer' }}>
          <span style={{ color: '#52C289' }}>Woo</span><span style={{ color: '#FF7043' }}>ki</span>
        </div>
        <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.12)', borderRadius: 100, padding: '6px 16px', fontSize: '0.78rem', color: 'rgba(255,255,255,0.85)', fontWeight: 700, marginBottom: 20, border: '1px solid rgba(255,255,255,0.2)' }}>
          🌿 Lancement — 0% commission
        </div>
        <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '2rem', color: 'white', lineHeight: 1.2, marginBottom: 16, maxWidth: 380, margin: '0 auto 16px', animation: 'fadeUp 0.6s ease both' }}>
          Partage ta passion avec des familles pres de toi
        </div>
        <div style={{ fontSize: '0.95rem', color: 'rgba(255,255,255,0.8)', lineHeight: 1.7, maxWidth: 340, margin: '0 auto 32px' }}>
          Propose tes activites sur Wooki — coaching sportif, cuisine, nature, art... Les familles de ton quartier t attendent.
        </div>
        <button onClick={() => navigate('/inscription-pro')} style={{ background: '#FF7043', color: 'white', border: 'none', borderRadius: 100, padding: '18px 36px', fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1.05rem', cursor: 'pointer', boxShadow: '0 8px 28px rgba(255,112,67,0.45)', animation: 'pulse 2s ease-in-out infinite', marginBottom: 16 }}>
          Proposer mon activite gratuitement
        </button>
        <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.55)' }}>Gratuit · Sans engagement · 2 minutes pour commencer</div>
      </div>

      {/* STATS */}
      <div style={{ background: 'white', padding: '24px 20px', display: 'flex', justifyContent: 'center', borderBottom: '1px solid #EEF2EE' }}>
        {[{ val: '100%', label: 'Gratuit\naujourd hui' }, { val: '0€', label: 'Commission\npour toi' }, { val: '2 min', label: 'Pour creer\nton profil' }].map((s, i) => (
          <div key={i} style={{ flex: 1, textAlign: 'center', borderRight: i < 2 ? '1px solid #EEF2EE' : 'none', padding: '0 8px' }}>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.6rem', color: '#3D9A6A' }}>{s.val}</div>
            <div style={{ fontSize: '0.68rem', color: '#8A9E8D', whiteSpace: 'pre-line', lineHeight: 1.4, marginTop: 2 }}>{s.label}</div>
          </div>
        ))}
      </div>

      <div style={{ padding: '32px 24px', maxWidth: 420, margin: '0 auto' }}>

        {/* ACTIVITÉS */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#1C2B1E', marginBottom: 8 }}>Quelle est ta passion ?</div>
          <div style={{ fontSize: '0.85rem', color: '#8A9E8D', marginBottom: 20 }}>Wooki accueille tous les profils — pro ou passionne</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
            {activites.map((a, i) => (
              <div key={i} style={{ background: 'white', borderRadius: 100, padding: '8px 14px', fontSize: '0.82rem', fontWeight: 700, color: '#4A6355', boxShadow: '0 2px 8px rgba(28,43,30,0.08)', display: 'flex', alignItems: 'center', gap: 6 }}>
                {a.emoji} {a.label}
              </div>
            ))}
            <div style={{ background: '#EDF7F1', borderRadius: 100, padding: '8px 14px', fontSize: '0.82rem', fontWeight: 700, color: '#3D9A6A' }}>+ et bien d autres !</div>
          </div>
        </div>

        {/* COMMENT CA MARCHE */}
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#1C2B1E', marginBottom: 20, textAlign: 'center' }}>Comment ca marche ?</div>
          {etapes.map((e, i) => (
            <div key={i} style={{ display: 'flex', gap: 16, alignItems: 'flex-start', marginBottom: 20 }}>
              <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'linear-gradient(135deg, #3D9A6A, #52C289)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <span style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: 'white' }}>{e.num}</span>
              </div>
              <div style={{ flex: 1, paddingTop: 4 }}>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#1C2B1E', marginBottom: 4 }}>{e.titre}</div>
                <div style={{ fontSize: '0.82rem', color: '#8A9E8D', lineHeight: 1.6 }}>{e.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* REGLE */}
        <div style={{ background: 'linear-gradient(135deg, #EDF7F1, #D4EEE0)', borderRadius: 24, padding: '20px', marginBottom: 28 }}>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#1C2B1E', marginBottom: 12 }}>🌿 La regle Wooki la plus importante</div>
          {['👨‍👩‍👧 Les parents restent presents pendant toute l activite', '📍 L activite se deroule dans un lieu public', '👶 Tu definis le nombre min. et max. d enfants', '📋 Tu es responsable — Wooki met en relation uniquement'].map((r, i) => (
            <div key={i} style={{ fontSize: '0.85rem', color: '#4A6355', lineHeight: 1.5, padding: '6px 0', borderBottom: i < 3 ? '1px solid #C5DFC9' : 'none' }}>{r}</div>
          ))}
        </div>

        {/* TEMOIGNAGE */}
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 28 }}>
          <div style={{ fontSize: '2rem', color: '#3D9A6A', marginBottom: 8, fontFamily: 'Georgia, serif' }}>"</div>
          <div style={{ fontSize: '0.88rem', color: '#4A6355', lineHeight: 1.7, marginBottom: 12, fontStyle: 'italic' }}>
            J ai propose mon premier atelier patisserie pour 8 enfants. En 3 jours j avais deja 6 familles interessees !
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg, #FF7043, #FFB300)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Fredoka One, cursive', color: 'white', fontSize: '0.9rem' }}>M</div>
            <div>
              <div style={{ fontWeight: 800, fontSize: '0.85rem', color: '#1C2B1E' }}>Marie</div>
              <div style={{ fontSize: '0.72rem', color: '#8A9E8D' }}>Patissiere · Valence</div>
            </div>
            <div style={{ marginLeft: 'auto', color: '#FFB300' }}>⭐⭐⭐⭐⭐</div>
          </div>
        </div>

        {/* FAQ */}
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#1C2B1E', marginBottom: 16, textAlign: 'center' }}>Questions frequentes</div>
          {faqs.map((f, i) => (
            <div key={i} style={{ background: 'white', borderRadius: 16, marginBottom: 8, overflow: 'hidden', boxShadow: '0 2px 8px rgba(28,43,30,0.06)' }}>
              <div onClick={() => setShowFaq(showFaq === i ? null : i)} style={{ padding: '14px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                <div style={{ fontWeight: 700, fontSize: '0.88rem', color: '#1C2B1E', flex: 1, paddingRight: 12 }}>{f.q}</div>
                <div style={{ color: '#3D9A6A', transition: 'transform 0.2s', transform: showFaq === i ? 'rotate(180deg)' : 'rotate(0)' }}>▼</div>
              </div>
              {showFaq === i && (
                <div style={{ padding: '0 16px 14px', fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.7, borderTop: '1px solid #F3F4F2' }}>{f.r}</div>
              )}
            </div>
          ))}
        </div>

        {/* CTA FINAL */}
        <div style={{ background: 'linear-gradient(135deg, #1C2B1E, #2D7A52)', borderRadius: 28, padding: '28px 24px', textAlign: 'center' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>🚀</div>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: 'white', marginBottom: 8 }}>Pret a te lancer ?</div>
          <div style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.75)', lineHeight: 1.6, marginBottom: 20 }}>Gratuit, sans engagement, 2 minutes pour commencer.</div>
          <button onClick={() => navigate('/inscription-pro')} style={{ width: '100%', padding: '17px', background: '#FF7043', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: 'pointer', marginBottom: 12, boxShadow: '0 6px 20px rgba(255,112,67,0.4)' }}>
            🌿 Creer mon profil gratuitement
          </button>
          <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.5)' }}>En creant ton profil tu acceptes les CGU de Wooki</div>
        </div>

      </div>
    </div>
  );
}